import styled from 'styled-components';

export const SubscriptionStatusWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px 10px;

  column-gap: 4px;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 140%;

  cursor: pointer;

  background: #f5f7fa;
  border-radius: 24px;

  & .subscription-icon {
    font-size: 16px;
  }

  & .chevron-icon {
    font-size: 16px;
  }

  &.active .subscription-icon {
    color: #42ad52;
  }

  &.pause .subscription-icon {
    color: #f9de33;
  }

  &.cancel .subscription-icon {
    color: #f24e1e;
  }

  &.expiring-soon .subscription-icon {
    color: #ff9900;
  }
`;
